import { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'foundations-components/transitional/components/Popover';
import GoVideoPopoverContent from './GoVideoPopoverContent';
import { jsx as _jsx } from "react/jsx-runtime";
class GoVideoPopover extends Component {
  constructor(...args) {
    super(...args);
    this.renderPopoverContent = () => {
      const {
        isInServiceHub,
        onChange,
        onClose,
        trackingHandlers,
        recipientEmail,
        isInlineVideo,
        showTitleCheckBox
      } = this.props;
      return /*#__PURE__*/_jsx(GoVideoPopoverContent, {
        isInServiceHub: isInServiceHub,
        onChange: onChange,
        onClose: onClose,
        trackingHandlers: trackingHandlers,
        recipientEmail: recipientEmail,
        isInlineVideo: isInlineVideo,
        showTitleCheckBox: showTitleCheckBox
      });
    };
  }
  render() {
    const {
      open,
      placement,
      children
    } = this.props;
    return /*#__PURE__*/_jsx(Popover, {
      open: open,
      inlineSize: "625px",
      blockSize: "437px",
      placement: placement,
      autoPlacement: true,
      content: this.renderPopoverContent(),
      children: children
    });
  }
}
GoVideoPopover.propTypes = {
  children: PropTypes.any,
  isInServiceHub: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  placement: PropTypes.string,
  trackingHandlers: PropTypes.object,
  recipientEmail: PropTypes.string,
  isInlineVideo: PropTypes.bool,
  showTitleCheckBox: PropTypes.bool
};
GoVideoPopover.defaultProps = {
  placement: 'top left'
};
export default GoVideoPopover;